<script setup lang="ts">
import { computed } from 'vue'

const {
  values = [],
  colors = [],
  max = 100,
} = defineProps<{
  values?: number[]
  colors?: string[]
  max?: number
}>()

const value = computed(() =>
  Math.min(max, values.reduce((prev, curr) => prev + curr, 0)))

const percentage = computed(() => (value.value / Math.max(max, 1)) * 100)

const segmentWidth = (val: number) => `${(val / Math.max(max, 1)) * 100}%`
</script>

<template>
  <div
    class="bg-gray-10 flex h-4 w-full min-w-26 overflow-hidden rounded-full"
    role="progressbar"
    :aria-valuemin="0"
    :aria-valuemax="max"
    :aria-valuenow="value"
    :data-percentage="percentage"
  >
    <span
      v-for="(val, index) of values"
      :key="`${index}-${val}`"
      class="bg-green-40 my-0.5 first:ml-0.5 first:rounded-l-xl last:mr-0.5 last:rounded-r-xl"
      :style="{
        width: segmentWidth(val),
        backgroundColor: colors[index] ?? 'var(--color-green-40)',
      }"
      aria-hidden="true"
    />
  </div>
</template>
